/* eslint-disable @typescript-eslint/no-explicit-any */

// 10 кадров при 60 герцах
const DEFAULT_WAIT = 166;

/**
 * Минималистичная реализация алгоритма throttle
 *
 * @export
 * @template T
 * @param {T} func
 * @param {*} [wait=166]
 * @return {*}  {(T & ICancelable)}
 */
export function throttle(func) {
  let wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_WAIT;
  let timeout;
  let isInProgress = false;
  function throttled() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (isInProgress) {
      return;
    }
    isInProgress = true;
    const later = () => {
      // @ts-expect-error any
      func.apply(this, args);
      clearTimeout(timeout);
      isInProgress = false;
    };
    timeout = setTimeout(later, wait);
  }
  throttled.cancel = () => {
    clearTimeout(timeout);
  };
  return throttled;
}